export function StoreWrapper<T>(props: {
    useStore(): T;
    render?(store: T): JSX.Element | null;
    children?(store: T): JSX.Element | null;
}) {
    const store = props.useStore();
    return props.render?.(store) ?? props.children?.(store) ?? null;
}
